import {createContext} from "react";
import {OperationalEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {OperationalEntityContextValue} from "./OperationalEntityContextValue";

export const OperationalEntityContext =
  createContext<OperationalEntityContextValue>({
    entity: {} as OperationalEntity,
    setEntity: entity => {}
  });
